import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import DeletePopUp from '../Shared/DeletePopUp';
import { toast } from 'react-toastify';
import { useDeletePrivilegeMutation } from '../../Store/Services/privilegeService';
import { closePrivilegeModal } from '../../Store/Slices/privilegeSlice';


const DeletePrivilege = () => {

    const dispatch = useDispatch();
    const privilege = useSelector((state) => state.privilege);

    const [deletePrivilege] = useDeletePrivilegeMutation();

    const onDeleteConfirm = async () => {
        const id = privilege.selectedPrivilege;
        try {
            const deletedPrivilege = await deletePrivilege(id).unwrap();
            // toast.success("Privilege successfully deleted!");
        } catch (err) {
            console.error('Failed to delete the privilege: ', err)
            toast.error("Erorr, something went wrong!");
        }
        dispatch(closePrivilegeModal());
    }

    return (
        <DeletePopUp
            data="Privilege"
            close={() => dispatch(closePrivilegeModal())}
            onDeleteConfirm={onDeleteConfirm}
        />
    )
}

export default DeletePrivilege